import { createContext } from "react";


const roomContext = createContext({
});

export default roomContext;